import { render, staticRenderFns } from "./OrbitClaimBar.vue?vue&type=template&id=0846bbb7&scoped=true"
import script from "./OrbitClaimBar.vue?vue&type=script&lang=ts"
export * from "./OrbitClaimBar.vue?vue&type=script&lang=ts"
import style0 from "./OrbitClaimBar.vue?vue&type=style&index=0&id=0846bbb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0846bbb7",
  null
  
)

export default component.exports